import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '../../atoms/button'

import {
  StyledContent,
  StyledInfoText,
  StyledIcon,
  StyledTextIconContainer,
} from './styles'

const Simple2Modal = (props) => {
  const { img, text, buttonText, onSubmit } = props

  return (
    <StyledContent>
      <StyledTextIconContainer>
        <StyledIcon src={img} />
        <StyledInfoText
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </StyledTextIconContainer>
      <Button expand onClick={onSubmit}>
        {buttonText}
      </Button>
    </StyledContent>
  )
}

Simple2Modal.propTypes = {
  img: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  onSubmit: PropTypes.func,
}

export { Simple2Modal }
